module.exports = __webpack_public_path__ + "assets/img/copper-zi.57826071.png";